import * as React from 'react';

import Collapse from 'antd/lib/collapse/Collapse';

import '@app/scss/ui/collapsible/collapsible.scss';

interface CollapsibleProps {
	in: boolean;
	id: string;

	children: React.ReactNode;
}

export const Collapsible: React.FC<CollapsibleProps> = (props: CollapsibleProps) => (
	<Collapse
		ghost
		activeKey={props.in ? props.id : undefined}
		className="collapsible"
	>
		<Collapse.Panel
			key={props.id}
			header={null}
			showArrow={false}
			collapsible="disabled"
		>
			{props.children}
		</Collapse.Panel>
	</Collapse>
);
